import { createSlice } from '@reduxjs/toolkit';
import { difference, union } from 'es-toolkit';

import { loadCatalogAd } from './catalogAd.actions';
import { categories, generateAdKey } from './catalogAd.helpers';
import { CatalogAds, defaultCatalogAdState, emptyAdUnit } from './catalogAd.types';

const catalogAdSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(loadCatalogAd.pending, (state, { meta }) => {
            const { categoryIds, keywords, pageName } = meta.arg;
            const key = generateAdKey({ categoryIds, keywords, pageName });
            state.loading = union(state.loading, [key]);
        });

        builder.addCase(loadCatalogAd.fulfilled, (state, { payload }) => {
            state.loaded[payload.key] = payload.actionTime;
            state.loading = difference(state.loading, [payload.key]);
            if (payload.data.ads.length && payload.key.includes('navigation')) {
                payload.data.ads.forEach((ad) => {
                    if (categories[ad.categoryId]) {
                        const key = generateAdKey({
                            categoryIds: `${ad.categoryId}`,
                            pageName: 'navigation',
                        });
                        state.byId[key] = ad;
                    }
                });
            } else if (payload.data.ads.length === 0 && payload.key.includes(CatalogAds.SearchPageBanner)) {
                // item-api will return an empty ad array when the search-page-banner ad should not be displayed
                // in that case, we should overwrite whatever search-page-banner ad is in redux with an empty ad
                state.byId[payload.key] = emptyAdUnit;
            } else if (payload.data.ads.length) {
                state.byId[payload.key] = payload.data.ads[0];
            }
        });

        builder.addCase(loadCatalogAd.rejected, (state, { meta }) => {
            const { categoryIds, keywords, pageName } = meta.arg;
            const key = generateAdKey({ categoryIds, keywords, pageName });
            state.loading = difference(state.loading, [key]);
        });
    },
    initialState: defaultCatalogAdState,
    name: 'catalogAd',
    reducers: {},
});

export const { reducer: catalogAdReducer } = catalogAdSlice;
